import React from 'react';
import EventCategoryLayout from '../../components/EventCategoryLayout';

const OtherEvents = () => {
  return <EventCategoryLayout categoryId="other" />;
};

export default OtherEvents;
